<div>        
    <button mat-fab aria-label="Example icon button with a delete icon" aria-label="close">
        <mat-icon>clear</mat-icon>
    </button>
</div>